const NotificationSkeletonRow = ({ item }: { item: number }) => (
  <div className='single-notification notification-skeleton-row' key={item}>
    <div className='notification-skeleton-avatar' />
    <div className='notification-content'>
      <span className='notification-skeleton-line notification-skeleton-context' />
      <div className='notification-skeleton-meta'>
        <span className='notification-skeleton-line notification-skeleton-author' />
        <span className='notification-skeleton-line notification-skeleton-time' />
      </div>
      <span className='notification-skeleton-line notification-skeleton-text' />
      <span className='notification-skeleton-line notification-skeleton-text short' />
    </div>
  </div>
);

const NotificationSkeletonSection = ({ rows }: { rows: number[] }) => (
  <>
    <div className='daywise-notification'>
      <span className='notification-skeleton-line notification-skeleton-date' />
    </div>
    {rows.map((item) => (
      <NotificationSkeletonRow item={item} key={item} />
    ))}
  </>
);

const NotificationListSkeleton = () => (
  <div className='notification-list-scroll notification-list-skeleton'>
    <NotificationSkeletonSection rows={[0, 1]} />
    <NotificationSkeletonSection rows={[2, 3]} />
  </div>
);

export default NotificationListSkeleton;
